import { render, staticRenderFns } from "./ModalCreatePassCode.vue?vue&type=template&id=cfbaf420&scoped=true&"
import script from "./ModalCreatePassCode.vue?vue&type=script&lang=ts&"
export * from "./ModalCreatePassCode.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCreatePassCode.vue?vue&type=style&index=0&id=cfbaf420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbaf420",
  null
  
)

export default component.exports